(() => {
  // --- AYARLAR ---
  const CONFIG = {
    threshold: 2000,
    giftHandle: 'organik-camasir-deterjani-750-ml',
    autoTag: '_auto_gift_night'
  };

  // --- KAMPANYA ZAMAN AYARLARI ---
  const CAMPAIGN = {
    startDate: { year: 2026, month: 2, day: 23 },
    endDate:   { year: 2026, month: 3, day: 1  },
    nightStart: 20,
    nightEnd:   10
  };

  function isCampaignActive() {
    const now = new Date();
    const trTime = new Date(now.toLocaleString('en-US', { timeZone: 'Europe/Istanbul' }));

    const year  = trTime.getFullYear();
    const month = trTime.getMonth() + 1;
    const day   = trTime.getDate();
    const hour  = trTime.getHours();

    const s = CAMPAIGN;
    const toNum = (y, m, d) => y * 10000 + m * 100 + d;
    const nowNum   = toNum(year, month, day);
    const startNum = toNum(s.startDate.year, s.startDate.month, s.startDate.day);

    const dayAfterEnd = (() => {
      const d = new Date(s.endDate.year, s.endDate.month - 1, s.endDate.day + 1);
      return toNum(d.getFullYear(), d.getMonth() + 1, d.getDate());
    })();

    if (nowNum < startNum || nowNum > dayAfterEnd) return false;

    const inNightHours = (hour >= s.nightStart) || (hour < s.nightEnd);
    if (!inNightHours) return false;

    if (nowNum === startNum && hour < s.nightStart) return false;
    if (nowNum === dayAfterEnd && hour >= s.nightEnd) return false;

    return true;
  }

  let isProcessing = false;
  let pendingCheck = false;

  async function getGiftId() {
    try {
      const res = await fetch(`/products/${CONFIG.giftHandle}.js`);
      if (!res.ok) return null;
      const data = await res.json();
      return data.variants?.[0]?.id || null;
    } catch (e) { return null; }
  }

  // ✅ Dawn'ın kendi render pipeline'ını kullanır — stabil, DOM kurcalamaz
  async function forceUpdateCartUI() {
    try {
      const cartDrawer = document.querySelector('cart-drawer');
      if (!cartDrawer) return;

      const sectionsToRender = cartDrawer.getSectionsToRender().map(s => s.id);
      const res = await fetch(`/?sections=${sectionsToRender.join(',')}`);
      if (!res.ok) return;

      const sections = await res.json();
      cartDrawer.renderContents({ sections });

    } catch (err) {
      console.error('[Gece Kampanyası] UI güncelleme hatası:', err);
    }
  }

  async function removeGiftIfExists(giftId) {
    const cartRes = await fetch('/cart.js');
    const cart = await cartRes.json();
    const freeItem = cart.items.find(
      i => i.variant_id === giftId && i.properties?.[CONFIG.autoTag] === 'true'
    );
    if (freeItem) {
      console.log('[Gece Kampanyası] Kampanya dışı, hediye siliniyor...');
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: freeItem.key, quantity: 0 })
      });
      await forceUpdateCartUI();
    }
  }

  async function checkRules() {
    if (isProcessing) {
      pendingCheck = true;
      return;
    }
    isProcessing = true;
    pendingCheck = false;

    try {
      const giftId = await getGiftId();
      if (!giftId) {
        console.warn('[Gece Kampanyası] Hediye ürünü bulunamadı:', CONFIG.giftHandle);
        return;
      }

      if (!isCampaignActive()) {
        await removeGiftIfExists(giftId);
        return;
      }

      const cartRes = await fetch('/cart.js');
      const cart = await cartRes.json();

      const freeItem = cart.items.find(
        i => i.variant_id === giftId && i.properties?.[CONFIG.autoTag] === 'true'
      );
      const paidItem = cart.items.find(
        i => i.variant_id === giftId && (!i.properties || i.properties[CONFIG.autoTag] !== 'true')
      );

      let realTotal = cart.total_price;
      if (freeItem) realTotal -= freeItem.final_line_price;

      const thresholdCents = CONFIG.threshold * 100;
      let actionNeeded = false;

      if (realTotal >= thresholdCents) {
        if (freeItem) {
          if (freeItem.quantity > 1) {
            console.log('[Gece Kampanyası] Fazla hediye adedi düzeltiliyor...');
            await fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: freeItem.key, quantity: 1 })
            });
            actionNeeded = true;
          }
        } else {
          if (paidItem) {
            console.log('[Gece Kampanyası] Ücretli ürün hediyeye dönüştürülüyor...');
            if (paidItem.quantity === 1) {
              await fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                  id: paidItem.key,
                  properties: { [CONFIG.autoTag]: 'true' }
                })
              });
            } else {
              await fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: paidItem.key, quantity: paidItem.quantity - 1 })
              });
              await fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                  items: [{ id: giftId, quantity: 1, properties: { [CONFIG.autoTag]: 'true' } }]
                })
              });
            }
            actionNeeded = true;
          } else {
            console.log('[Gece Kampanyası] Limit aşıldı, hediye ekleniyor...');
            await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                items: [{ id: giftId, quantity: 1, properties: { [CONFIG.autoTag]: 'true' } }]
              })
            });
            actionNeeded = true;
          }
        }
      } else {
        if (freeItem) {
          console.log('[Gece Kampanyası] Limit altı, hediye siliniyor...');
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: freeItem.key, quantity: 0 })
          });
          actionNeeded = true;
        }
      }

      if (actionNeeded) await forceUpdateCartUI();

    } catch (err) {
      console.error('[Gece Kampanyası Hatası]', err);
    } finally {
      isProcessing = false;
      if (pendingCheck) {
        setTimeout(checkRules, 600);
      }
    }
  }

  // --- TETİKLEYİCİLER ---
  document.addEventListener('DOMContentLoaded', () => setTimeout(checkRules, 1200));

  const originalFetch = window.fetch;

  window.fetch = async function (...args) {
    const url = args[0] && (typeof args[0] === 'string' ? args[0] : args[0]?.url);
    const isCartMutation = url && (
      url.includes('/cart/add') ||
      url.includes('/cart/change') ||
      url.includes('/cart/update') ||
      url.includes('/cart/clear')
    );

    const response = await originalFetch.apply(this, args);

    if (isCartMutation && !isProcessing) {
      setTimeout(checkRules, 700);
    }

    return response;
  };

})();